var Shuffle = window.Shuffle;

class FirehawkCRMGridPicker {
	container = null
	listElement = null
	loadingElement = null
	collapseHeader = null
	pagination = null
	shuffle = null;
	searchIndex = null
	searchRoute = null
	searchTags = []
	customArrayTerms = []

	minimumTagMatch = null
	multiselect = false
	searchRequest = null

	// Search params
	pages = {}
	totalPages = 0
	totalItems = 0
	page = -1
	pageSize = 30
	currentQuery = null;

	selectedItemId = null
	selectedItem = null
	selectedItems = []

	tagCategoryGroup = null
	tagCategory = null
	selectedTag = null
	tags = []
	hasTags = false

	modalElement = null
	gridModal = null

	showInWeb = null;

	itemDeselected = null
	itemSelected = null

	layout = null
	excludeTax = false;
	sorting = {position:"asc"}
	columns = 3

	defaultValue = null
	changeButtonTitle = "Change"

	collapsable = false
	collapseController = null

	selectedItemOnOpen = null

	packageUpgrade = false
	packageUpgradeTag = null
	packageUpgradeBaseItem = null
	currencySymbol = "$"

	useDescriptionForName = false

	addToCart = false;

	constructor(container, element, pagination, searchIndex, route, pageSize = 30, searchTags = [], showInWeb, multiselect, collapsable = false, changeButtonTitle, tagCategoryGroup) {
		this.container = container
		this.searchIndex = searchIndex
		this.searchRoute = route
		this.searchTags = searchTags
		this.showInWeb = showInWeb
		this.multiselect = multiselect
		this.listElement = jQuery(element)
		this.pagination = pagination
		this.collapsable = collapsable
		this.changeButtonTitle = changeButtonTitle || "Change"
		this.tagCategoryGroup = tagCategoryGroup
		this.loadingElement = jQuery(`<div class="grid-loading scale-in-center"><div class="firehawk-crm-search-spinner primary lg"></div></div>`)

		this.pages = {}
		this.totalPages = 0
		this.page = -1;
		this.pageSize = typeof pageSize == "number" ? pageSize : 30

		this.gridActionsElement = jQuery(`<div class="actions"><button type="button" class="btn btn-light back-btn"><i class="far fa-regular fa-angle-left" style="margin-right: 5px;"></i>Back</button><span class="category-title"></span></div>`)
		this.gridActionsElement.addClass("d-none")
		this.container.prepend(this.gridActionsElement)

		if (collapsable == true) {
			if (this.container.find('.collapse-container').length) {
				this.collapseHeader = this.container.find(".grid-picker-header")
			} else {
				this.container.wrapInner("<div class='collapse-container collapse'></div>")
				this.collapseHeader = jQuery(`
				<div class="grid-picker-header collapsed">
					<div class="header-info">
						<div class="display-image"></div>
						<div class="info">
							<div class="title"></div>
							<div class="subtitle"></div>
						</div>
					</div>
					<div class="price"></div>
					<button class="btn btn-outline-dark edit-btn" type="button">${this.changeButtonTitle || "Change" }</button>
				</div>
				`)

				this.container.prepend(this.collapseHeader)

				this.listElement = this.container.find(".grid")
				this.pagination = this.container.find(".firehawk-crm-pg")

				// this.container.find(".collapse-container").append(`<div class="collapse-actions"><button class="btn btn-outline-dark bg-white cancel-btn" type="button">Cancel</button><button class="btn btn-primary confirm-btn" type="button">Confirm Changes</button></div>`)
			}

			let collapseContainer = this.container.find(".collapse-container")[0]
			if (collapseContainer) {
				this.collapseController = new bootstrap.Collapse(collapseContainer, {
					toggle: false
				})

				this.collapseController.hide()
				this.container.find(".collapse-container").removeClass("show")
			}

			this.updateHeadingInformation()
		}

		this.shuffle = new Shuffle(element, {
			itemSelector: '.grid-item',
			sizer: '.my-sizer-element'
		});
		this.waitToRefreshShuffleGrid()
		this.observer()
	}

	waitToRefreshShuffleGrid(){
		document.querySelectorAll(".firehawk-crm-form-page").forEach(element => {
			const observer = new MutationObserver(function(mutationsList) {
				for (let mutation of mutationsList) {
					if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
						if (element.classList.contains('active')) {
							window.dispatchEvent(new Event('resize'));
						}
					}
				}
			});
			observer.observe(element, { attributes: true });
		})
	}

	updateLayout() {
		this.clearEqualHeightForShuffleItems()
		this.shuffle.update()
		if (this.layout == "product-card") {
			// this.setEqualHeightForShuffleItems(this.listElement.find('.grid-item'))
		}

		this.setEqualHeightForShuffleItems(this.listElement.find('.grid-item'))
		this.shuffle.update()
	}

	buildCategoryGrid(items) {
		var content = ""
		var elements = []
		if (items && items.length) {
			for (var item of items) {
				let gridItem = this.buildCategoryGridItem(item)
				elements.push(gridItem.get(0))
				this.shuffle.element.appendChild(gridItem.get(0));
			}
		} else {
			let html = `<div class="empty-message"><div class="inner">No results found. Try expanding your search options.</div></div>`
			var div = document.createElement('div');
			div.innerHTML = html
			let element = div.firstChild
			elements.push(element)
			this.shuffle.element.appendChild(element);
		}

		this.shuffle.add(elements)

		window.dispatchEvent(new Event('resize'));
	}

	buildGrid(items) {
		var content = ""
		var elements = []
		if (items && items.length) {

			if (this.packageUpgrade && this.packageUpgradeBaseItem) {
				let gridItem = this.buildPackageDefaultGridItem(this.packageUpgradeBaseItem)
				elements.push(gridItem.get(0))
				this.shuffle.element.appendChild(gridItem.get(0));
			}
			for (var item of items) {
				let gridItem = this.buildGridItem(item)
				elements.push(gridItem.get(0))
				this.shuffle.element.appendChild(gridItem.get(0));
			}
		} else {
			let html = `<div class="empty-message"><div class="inner">No results found. Try expanding your search options.</div></div>`
			var div = document.createElement('div');
			div.innerHTML = html
			let element = div.firstChild
			elements.push(element)
			this.shuffle.element.appendChild(element);
		}

		this.shuffle.add(elements)

		this.updateLayout()
	}

	buildGridItem(item) {
		switch (this.layout) {
			case "product-card":
				return this.buildProductCardGridItem(item, false)
			case "compact-product-card":
				return this.buildProductCardGridItem(item, true)
			default:
				return this.buildDefaultGridItem(item)
		}
	}

	buildProductCardGridItem(item, compact) {
		var isActive = this.selectedItem && this.selectedItem.id == item.id || this.multiselect && this.selectedItems.filter(s => s.id == item.id).length > 0
		var gridItem = jQuery( `<div class="grid-item product-card ${isActive ? "active" : ""}" data-grid-id="${item.id}" tabindex="0"></div>`)
		var panelContent = jQuery(`<div class="panel-content"></div>`);

		var panelTitle = jQuery(`<div class="panel-title"></div>`)
		panelTitle.append(`<div class="title">${this.useDescriptionForName ? (item.invoiceDescription || item.name) : item.name}</div>`)

		var price = ""
		var priceValue = this.calculatePriceForItem(item)

		if (this.addToCart && this.packageUpgrade) {
			if (!item.cartParams) item.cartParams = {}
			item.cartParams.priceValues = {
				priceInclTax: priceValue,
				priceExclTax: priceValue
			}
		}

		if (this.packageUpgrade) {
			price = `+ ${this.currencySymbol}${priceValue}`
		} else {
			price = `${this.currencySymbol}${priceValue}`
		}

		if (price != null) {
			panelTitle.append(`<div class="price">${price}</div>`)
		}

		panelContent.append(panelTitle)

		if (item.description && !compact) {
			panelContent.append(`<div class="description">${item.description}</div>`)
		}

		var panel = jQuery(`<div class="panel"></div>`);
		panel.append(`<div class="checkbox-icon"><i class="far fa fa-regular fa-check check-icon"></i></div>`)
		panel.append(panelContent)
		if (compact) {
			panel.append(`<button class="btn btn-light btn-round info-btn"><i class="fas fa-info"></i></button>`)
		}
		gridItem.append(panel)

		return gridItem
	}

	buildDefaultGridItem(item) {
		var isActive = this.selectedItem && this.selectedItem.id == item.id || this.multiselect && this.selectedItems.filter(s => s.id == item.id).length > 0
		var gridItem = `<div class="grid-item fill-height ${isActive ? "active" : ""}" data-grid-id="${item.id}" tabindex="0"><div class="panel">`;

		gridItem += '<div class="cover-img"><div class="placeholder-img"><i class="fal fa-light fa-image" aria-hidden="true"></i></div>'
		if (item.displayImage) {
			gridItem += `<div class="main-img" style="background-image: url(${item.displayImage})"></div>`
		}

		gridItem += `<button class="btn btn-light btn-round info-btn"><i class="fas fa-solid fa-info"></i></button>`
		gridItem += '</div>'

		gridItem += `<div class="panel-content"><div class="title">${this.useDescriptionForName ? (item.invoiceDescription || item.name) : item.name}</div>`

		var price = ""
		var priceValue = this.calculatePriceForItem(item)

		if (this.addToCart && this.packageUpgrade) {
			item.cartParams.priceValues = {
				priceInclTax: priceValue,
				priceExclTax: priceValue
			}
		}

		if (this.packageUpgrade) {
			price = `+ ${this.currencySymbol}${priceValue}`
		} else {
			price = `${this.currencySymbol}${priceValue}`
		}

		if (price != null) {
			gridItem += `<div class="price">${price}</div>`
		}

		gridItem += `</div></div>`
		gridItem += `</div>`;

		return jQuery(gridItem)
	}

	buildPackageDefaultGridItem(item) {
		var isActive = this.selectedItem == null || this.packageUpgradeBaseItem && this.selectedItem.id == this.packageUpgradeBaseItem.id
		var gridItem = `<div class="grid-item default-option fill-height ${isActive ? "active" : ""}" tabindex="0"><div class="panel">`;

		gridItem += '<div class="cover-img"><div class="placeholder-img"><i class="fal fa-light fa-image" aria-hidden="true"></i></div>'
		if (item.displayImage) {
			gridItem += `<div class="main-img" style="background-image: url(${item.displayImage})"></div>`
		}

		gridItem += '</div>'

		gridItem += `<div class="panel-content"><div class="title">${this.useDescriptionForName ? (item.invoiceDescription || item.name) : item.name}</div>`
		gridItem += `<div class="price">Package Default</div>`
		gridItem += `</div></div>`
		gridItem += `</div>`;

		return jQuery(gridItem)
	}

	buildCategoryGridItem(item) {
		var gridItem = `<div class="grid-item" data-tag="${item.tag}" tabindex="0"><div class="panel">`;

		gridItem += '<div class="cover-img"><div class="placeholder-img"><i class="fal fa-light fa-image" aria-hidden="true"></i></div>'

		if (item.displayImage) {
			gridItem += `<div class="main-img" style="background-image: url(${item.displayImage})"></div>`
		} else if (item.imageUrl) {
			gridItem += `<div class="main-img" style="background-image: url(${item.imageUrl})"></div>`
		}

		gridItem += '</div>'

		gridItem += `<div class="panel-content"><div class="title">${this.useDescriptionForName ? (item.invoiceDescription || item.name) : item.name}</div>`

		gridItem += `</div></div>`
		gridItem += `</div>`;

		return jQuery(gridItem)
	}

	scrollTopList() {
		if (window.innerWidth > 1024) {
			return
		}
		jQuery('html, body').animate({
			scrollTop: jQuery(this.listElement).offset().top - 200
		}, 300);
	}

	showItemInfoModal(id) {
		var item = null
		for (var pageId in this.pages) {
			let page = this.pages[pageId]
			let match = page.items.filter(i => i.id == id)[0]
			if (match) {
				item = match
			}
		}

		if (!item) {
			return
		}

		const isSelected = this.selectedItem && this.selectedItem.id == id || this.multiselect && this.selectedItems.filter(s => s.id == id).length > 0

		var modal = '<div class="modal fade bs-modal grid-picker-modal firehawk-crm-style" id="fcrm-grid-modal-${item.id}" tabindex="-1" role="dialog" aria-hidden="true"><div class="modal-dialog modal-dialog-centered">'
		var modalImage = `<div class="cover-img ${item.displayImage == null ? "empty" : ""}"><div class="placeholder-img"><i class="fal fa-light fa-image" aria-hidden="true"></i></div>`
		if (item.displayImage) {
			modalImage += `<img class="main-img" src="${item.displayImage}"/>`
		}

		modalImage += '</div>'


		var price = ""
		var priceValue = 0
		var showPrices = true

		var price = ""
		var priceValue = this.calculatePriceForItem(item)

		if (this.packageUpgrade) {
			price = `+ ${this.currencySymbol}${priceValue}`
		} else {
			price = `${this.currencySymbol}${priceValue}`
		}

		modal += `<div class="modal-content">
					<div class="modal-header">
							<h4 class="modal-title">${this.useDescriptionForName ? (item.invoiceDescription || item.name) : item.name}</h4>
					</div>
					${modalImage}
					<div class="modal-body">`

		if (price && showPrices) {
			modal += `<div class="pricing"><small>Pricing</small><div class="price">${price}</div></div>`
		}

		if (item.description) {
			modal += `<div class="description"><small>Description</small><div>${item.description}</div></div>`
		}

		modal += `</div>
							<div class="modal-footer py-3">
								<button class="btn btn-outline-dark close-btn" type="button">Close</button>
								<button class="btn btn-outline-dark select-btn" type="button" data-grid-id="${item.id}">${isSelected ? "Deselect" : "Select"}</button>
							</div>
					</div>
					</div>
			</div>`

		let modalElement = jQuery(modal)
		jQuery('body').append(modalElement)
		let modalDom = modalElement.get(0)

		this.gridModal = new bootstrap.Modal(modalDom, {
		  fadeDuration: 250
		})

		modalDom.addEventListener('hidden.bs.modal', (event) => {
			if (this.modalElement) {
				jQuery(this.modalElement).remove()
			}
		})
		modalElement.delegate('.close-btn', 'click', (event) => {
			if (this.gridModal) {
				this.gridModal.hide();
			}
		})

		modalElement.delegate('.close-modal', 'click', (event) => {
			if (this.gridModal) {
				this.gridModal.hide();
			}
		})

		modalElement.delegate('.select-btn', 'click', (event) => {
			var item = jQuery(event.currentTarget);
			var id = item.data("grid-id")
			if (id) {
				this.selectItem(id)
			}
			if (this.gridModal) {
				this.gridModal.hide();
			}
		})

		this.gridModal.show()
	}

	hideLoading() {
		this.loadingElement.remove()
	}

	showLoading() {
		this.listElement.before(this.loadingElement)
	}

	fetchNextPage() {
		const nextPage = this.page + 1
		if (nextPage > this.totalPages - 1) return;
		this.fetchPage(nextPage, this.currentQuery)
	}

	fetchTagCategories() {
		this.showLoading()

		var items = [...this.shuffle.items]
		items.shift()
		this.shuffle.remove(items.map(e => e.element))

		jQuery.ajax({
			method: 'post',
			url: ajax_var.url,
			data: {
				action: 'get_tags',
				category: this.tagCategoryGroup
			}
		}).done((response) => {
			if (!response || !response.category || !response.tags || !response.tags.length) {
				this.hasTags = false
				this.fetchPage(0, null)
				return
			}

			this.tagCategory = response.category
			this.tags = response.tags || []
			this.hasTags = true
			this.buildCategoryGrid(this.tags)
			this.hideLoading()
		}).fail((error) => {
			console.error(error)
			this.hasTags = false
			this.fetchPage(0, null)
		})
	}

	fetchStockItem(id, callback) {
		jQuery.ajax({
			method: 'post',
			url: ajax_var.url,
			data: {
				action: 'get_stock_item',
				id: id
			}
		}).done((response) => {
			if (callback) {
				callback(response)
			}
		}).fail((error) => {
			console.error(error)
			if (callback) {
				callback(null)
			}
		})
	}

	fetchPage(page, query, ignorePage, refresh = false) {
		if (page == this.page && ignorePage != true) return;
		var from = this.pageSize * page

		var items = [...this.shuffle.items]
		items.shift()
		this.shuffle.remove(items.map(e => e.element))

		if (this.pages[page] && (!query || !query.length) && !refresh) {
			this.loadExistingPage(page)
			return
		}

		this.showLoading()
		this.currentQuery = query


		var customTerms = []
		var customArrayTerms = []
		var customMustNotTerms = []

		if (this.customArrayTerms) {
			for (let item of this.customArrayTerms) {
				customArrayTerms.push(item)
			}
		}
		if (this.tagCategory && this.tagCategory.key && this.selectedTag) {
			customTerms.push({ [`tag-categories.${this.tagCategory.key}.keyword`]: this.selectedTag })
		}

		if (this.packageUpgradeBaseItem && this.packageUpgradeBaseItem.id) {
			customMustNotTerms.push({ "_id": this.packageUpgradeBaseItem.id })
		}

		var searchParams = {
			index: this.searchIndex,
			route: this.searchRoute,
			from: from,
			size: this.pageSize,
			query: query,
			customTerms: customTerms,
			customArrayTerms: customArrayTerms,
			customMustNotTerms: customMustNotTerms,
			tags: this.searchTags,
			onlyShowInWeb: this.showInWeb == "yes",
			sorting: [this.sorting]
		}

		if (this.minimumTagMatch) {
			searchParams.tagsMinShouldMatch = this.minimumTagMatch
		}

		if (this.searchRequest) {
			this.searchRequest.abort()
		}
		
		this.searchRequest = jQuery.ajax({
			method: 'post',
			url: ajax_var.url,
			data: {
				action: 'perform_search',
				params: searchParams
			}
		}).done((response) => {
			var results = JSON.parse(response)

			if (!results || !results.results) {
				this.hideLoading()
				return
			}

			this.totalItems = results.total || 0
			this.totalPages = Math.ceil(this.totalItems / this.pageSize);
			this.page = page
			let items = results.results
			items = items.map((item) => {
				item.cartParams = {}
				return item
			})

			if (!query) {
				this.pages[page] = {
					page: page,
					items: items
				}
			}

			if (!this.selectedItem && this.defaultValue) {
				this.selectItem(this.defaultValue)
			}

			this.updatePagination()
			this.buildGrid(items)
			this.hideLoading()
		}).fail((error) => {
			console.error(error)
			this.hideLoading()
		})
	}

	updatePagination() {
		if (!this.pagination) return;

		var self = this;
		var currentPage = self.page + 1
		var pageRange = 2;
		var totalPage = self.totalPages

		var rangeStart = currentPage - pageRange;
		var rangeEnd = currentPage + pageRange;

		if (rangeEnd > totalPage) {
			rangeEnd = totalPage;
			rangeStart = totalPage - pageRange * 2;
			rangeStart = rangeStart < 1 ? 1 : rangeStart;
		}

		if (rangeStart <= 1) {
			rangeStart = 1;
			rangeEnd = Math.min(pageRange * 2 + 1, totalPage);
		}

		if (totalPage <= 1) {
			this.pagination.innerHTML = null
			return
		}

		var pageLink = ''
		var prevText = '&laquo;';
		var nextText = '&raquo;';
		var ellipsisText = '...';

		var activeClassName = 'active'
		var disableClassName = 'disabled'
		var showFirstOnEllipsisShow = true
		var showLastOnEllipsisShow = true
		var html = '';
		var i;

		// Whether to display header
		html += '<div class="firehawk-crm-pg-pages">';

		html += '<ul>';

		// Whether to display the Previous button
		if (currentPage <= 1) {

		} else {
			html += '<li class="firehawk-crm-pg-previous" data-num="' + (currentPage - 1) + '" title="Previous page"><a href="' + pageLink + '">' + prevText + '<\/a><\/li>';
		}


		// Whether to display the pages
		if (rangeStart <= 3) {
			for (i = 1; i < rangeStart; i++) {
				if (i == currentPage) {
					html += '<li class="firehawk-crm-pg-page ' + activeClassName + '" data-num="' + i + '"><a>' + i + '<\/a><\/li>';
				} else {
					html += '<li class="firehawk-crm-pg-page" data-num="' + i + '"><a href="' + pageLink + '">' + i + '<\/a><\/li>';
				}
			}
		} else {
			if (showFirstOnEllipsisShow) {
				html += '<li class="firehawk-crm-pg-first firehawk-crm-pg-page" data-num="1"><a href="' + pageLink + '">1<\/a><\/li>';
			}
			html += '<li class="firehawk-crm-pg-ellipsis ' + disableClassName + '"><a>' + ellipsisText + '<\/a><\/li>';
		}

		for (i = rangeStart; i <= rangeEnd; i++) {
			if (i == currentPage) {
				html += '<li class="firehawk-crm-pg-page ' + activeClassName + '" data-num="' + i + '"><a>' + i + '<\/a><\/li>';
			} else {
				html += '<li class="firehawk-crm-pg-page" data-num="' + i + '"><a href="' + pageLink + '">' + i + '<\/a><\/li>';
			}
		}

		if (rangeEnd >= totalPage - 2) {
			for (i = rangeEnd + 1; i <= totalPage; i++) {
				html += '<li class="firehawk-crm-pg-page" data-num="' + i + '"><a href="' + pageLink + '">' + i + '<\/a><\/li>';
			}
		} else {
			html += '<li class="firehawk-crm-pg-ellipsis ' + disableClassName + '"><a>' + ellipsisText + '<\/a><\/li>';

			if (showLastOnEllipsisShow) {
				html += '<li class="firehawk-crm-pg-last firehawk-crm-pg-page" data-num="' + totalPage + '"><a href="' + pageLink + '">' + totalPage + '<\/a><\/li>';
			}
		}


		if (currentPage >= totalPage) {

		} else {
			html += '<li class="firehawk-crm-pg-next" data-num="' + (currentPage + 1) + '" title="Next page"><a href="' + pageLink + '">' + nextText + '<\/a><\/li>';
		}

		html += '<\/ul><\/div>';
		this.pagination.innerHTML = html
	}

	observer() {
		var self = this
		if (!self.pagination) return;
		var el = jQuery(self.pagination);
		var container = jQuery(self.container);
		var collapseHeading = self.collapseHeader
		var grid = jQuery(self.listElement);

		el.delegate('.firehawk-crm-pg-page', 'click', function(event) {
			event.preventDefault()
			var current = jQuery(event.currentTarget);
			var pageNumber = jQuery.trim(current.attr('data-num'));

			if (!pageNumber || current.hasClass('disabled') || current.hasClass('active')) return;
			self.fetchPage(pageNumber - 1, self.currentQuery)
			self.scrollTopList()
		});

		// Previous button click
		el.delegate('.firehawk-crm-pg-previous', 'click', function(event) {
			event.preventDefault()
			var current = jQuery(event.currentTarget);
			var pageNumber = jQuery.trim(current.attr('data-num'));

			if (!pageNumber || current.hasClass('disabled')) return;
			self.fetchPage(pageNumber - 1, self.currentQuery)
			self.scrollTopList()
		});

		// Next button click
		el.delegate('.firehawk-crm-pg-next', 'click', function(event) {
			event.preventDefault()
			var current = jQuery(event.currentTarget);
			var pageNumber = jQuery.trim(current.attr('data-num'));
			if (!pageNumber || current.hasClass('disabled')) return;
			self.fetchPage(pageNumber - 1, self.currentQuery)
			self.scrollTopList()
		});

		grid.delegate('.grid-item', 'keypress', function(event) {
				if (event.which == 13) {
					event.preventDefault();
					var item = jQuery(event.currentTarget);
					var id = item.data("grid-id")
					var tag = item.data("tag")

					if (item.hasClass("default-option")) {
						self.removeValue()
					} else {
						if (tag) {
							self.onTagCategorySelected(tag)
						} else if (id) {
							self.gridItemClicked(id)
						}
					}
				}
		})

		grid.delegate('.grid-item .info-btn', 'click', function(event) {
				event.preventDefault()
				event.stopImmediatePropagation();
				var item = jQuery(event.currentTarget).parents(".grid-item");

				var id = item.data("grid-id")

				if (id) {
					self.showItemInfoModal(id)
				}
		})

		grid.delegate('.grid-item', 'click', function(event) {
				event.preventDefault()
				var item = jQuery(event.currentTarget);

				var id = item.data("grid-id")
				var tag = item.data("tag")

				if (item.hasClass("default-option")) {
					self.removeValue()
				} else {
					if (tag) {
						self.onTagCategorySelected(tag)
					} else if (id) {
						self.gridItemClicked(id)
					}
				}

		})

		this.gridActionsElement.delegate('.back-btn', 'click', (event) => {
			this.selectedTag = null
			this.gridActionsElement.addClass("d-none")

			var items = [...this.shuffle.items]
			items.shift()
			this.shuffle.remove(items.map(e => e.element))

			this.buildCategoryGrid(this.tags)
		})

		if (collapseHeading) {
			collapseHeading.delegate('.edit-btn', 'click', (event) => {
				event.preventDefault()
				event.stopImmediatePropagation();

				if (!this.selectedItemOnOpen) {
					this.selectedItemOnOpen = this.selectedItem
				}

				if (this.collapseController) {
					if (this.collapseController._isShown()) {
						this.collapseController.hide()
					} else {
						this.collapseController.show()
					}
				}
			})

			collapseHeading.on("click", (event) => {
				event.preventDefault()
				event.stopImmediatePropagation();
				if (this.collapseController) {
					if (this.collapseController._isShown()) {
						this.collapseController.hide()
					} else {
						this.collapseController.show()
					}
				}
			})
			container.delegate(".collapse-container", "shown.bs.collapse", (event) => {
				this.updateLayout()
				if (this.collapseHeader) {
					this.collapseHeader.removeClass("collapsed")
				}
			})

			container.delegate(".collapse-container", "show.bs.collapse", (event) => {
				if (this.collapseHeader) {
					this.collapseHeader.removeClass("collapsed")
				}
			})

			container.delegate(".collapse-container", "hidden.bs.collapse", (event) => {
				if (this.collapseHeader) {
					this.collapseHeader.addClass("collapsed")
				}
			})

			// container.delegate(".collapse-container .confirm-btn", "click", (event) => {
			// 	event.preventDefault()
			// 	event.stopImmediatePropagation();
			// 	if (this.collapseController) {
			// 		this.collapseController.hide()
			// 	}
			// })

			// container.delegate(".collapse-container .cancel-btn", "click", (event) => {
			// 	event.preventDefault()
			// 	event.stopImmediatePropagation();

			// 	if (this.selectedItem && this.selectedItemOnOpen && this.selectedItemOnOpen.id == this.selectedItem.id) {
			// 		this.selectedItemOnOpen = null
			// 		if (this.collapseController) {
			// 			this.collapseController.hide()
			// 		}
			// 		return
			// 	}

			// 	this.selectedItem = this.selectedItemOnOpen
			// 	if (this.selectedItem && this.selectedItem.id) {
			// 		this.selectItem(this.selectedItem.id)
			// 	} else {
			// 		if (this.itemDeselected) {
			// 			this.itemDeselected(this.selectedItem)
			// 		}
			// 		this.listElement.find(".active").removeClass("active")
			// 		this.selectedItemId = null
			// 		this.selectedItem = null
			// 	}

			// 	this.updateHeadingInformation()
			// 	this.selectedItemOnOpen = null
			// 	if (this.collapseController) {
			// 		this.collapseController.hide()
			// 	}
			// })
		}
	}

	onTagCategorySelected(tag) {
		this.selectedTag = tag
		this.gridActionsElement.removeClass("d-none")

		var tagInfo = this.tags.filter(t => t.tag == tag)[0]
		if (tagInfo && tagInfo.name) {
			this.gridActionsElement.find(".category-title").html(tagInfo.name)
		} else {
			this.gridActionsElement.find(".category-title").html("")
		}
		this.refresh()
	}

	gridItemClicked(id, autoSelect = true) {
		if (autoSelect) {
			this.selectItem(id)
		} else {
			this.showItemInfoModal(id)
		}
	}

	selectItem(id) {
		if (!this.multiselect) {
			this.listElement.find('.grid-item').removeClass("active")
		}

		var isSelected = this.selectedItem && this.selectedItem.id == id || this.multiselect && this.selectedItems.filter(s => s.id == id).length > 0
		
		if (isSelected) {
			var selectedItem = this.multiselect ? this.selectedItems.filter(s => s.id == id)[0] : this.selectedItem
			this.listElement.find(`[data-grid-id="${id}"]`).removeClass("active")

			if (this.packageUpgrade && this.packageUpgradeBaseItem && this.packageUpgradeBaseItem.id) {
				this.removeValue()
			} else {
				if (this.multiselect) {
					this.selectedItems = this.selectedItems.filter(s => s.id != id)
				} else {
					this.selectedItemId = null
					this.selectedItem = null
				}
				
				this.updateHeadingInformation()

				if (this.itemDeselected) {
					this.itemDeselected(selectedItem, this)
				}

				if (this.packageUpgrade && this.packageUpgradeBaseItem) {
					this.listElement.find('.grid-item.default-option').addClass("active")
				}
			}
		} else {
			var selectedItem = null

			for (var pageId in this.pages) {
				let page = this.pages[pageId]
				let item = page.items.filter(i => i.id == id)[0]

				if (item) {
					selectedItem = item

					if (this.multiselect) {
						this.selectedItems.push(item)
					} else {
						this.selectedItemId = id
						this.selectedItem = item
					}
	
					this.updateHeadingInformation()
				}
			}

			if (selectedItem) {
				this.listElement.find(`[data-grid-id="${id}"]`).addClass("active")
				if (this.addToCart && this.packageUpgrade) {
					var cartPrice = this.calculatePriceForItem(selectedItem)
					selectedItem.cartParams.priceValues = {
						priceInclTax: cartPrice,
						priceExclTax: cartPrice
					}
				}

				if (this.itemSelected) {
					this.itemSelected(selectedItem, this)
				}
			} else {
				this.fetchStockItem(id, (stock) => {
					if (stock) {
						selectedItem = stock

						if (this.multiselect) {
							this.selectedItems.push(stock)
						} else {
							this.selectedItemId = id
							this.selectedItem = stock
						}

						this.updateHeadingInformation()
						this.listElement.find(`[data-grid-id="${id}"]`).addClass("active")

						if (this.addToCart && this.packageUpgrade) {
							var cartPrice = this.calculatePriceForItem(selectedItem)
							selectedItem.cartParams.priceValues = {
								priceInclTax: cartPrice,
								priceExclTax: cartPrice
							}
						}

						if (this.itemSelected) {
							this.itemSelected(selectedItem, this)
						}
					}
				})
			}
		}
	}

	updateHeadingInformation() {
		if (!this.collapseHeader) return

		var selectedItem = this.selectedItem || this.packageUpgradeBaseItem
		if (selectedItem) {
			if (selectedItem.displayImage) {
				this.collapseHeader.find(".display-image").html("").removeClass("icon")
			} else {
				this.collapseHeader.find(".display-image").html(`<i class="${this.defaultIconDisplay}"></i>`).addClass("icon")
			}

			this.collapseHeader.find(".display-image").css("background-image", `url('${selectedItem.displayImage}')`)
			this.collapseHeader.find(".title").html(this.useDescriptionForName ? (selectedItem.invoiceDescription || selectedItem.name) : selectedItem.name)

			var price = ""
			var priceValue = this.calculatePriceForItem(selectedItem)
			if (this.packageUpgrade) {
				price = `+ ${this.currencySymbol}${priceValue}`
			} else {
				price = `${this.currencySymbol}${priceValue}`
			}

			this.collapseHeader.find(".subtitle").html(price || "")
		} else {
			this.collapseHeader.find(".display-image").css("background-image", "")

			if (this.defaultIconDisplay) {
				this.collapseHeader.find(".display-image").html(`<i class="${this.defaultIconDisplay}"></i>`).addClass("icon")
			} else {
				this.collapseHeader.find(".display-image").html("").removeClass("icon")
			}
			this.collapseHeader.find(".title").html("")
			this.collapseHeader.find(".subtitle").html("Please expand to make a selection")
		}
	}

	calculatePriceForItem(item) {
		var priceValue = 0
		if (item && item.pricing) {
			for (let itemPrice of item.pricing) {
				if (itemPrice.priceType == "retail") {
					if (this.excludeTax && itemPrice.priceValues && itemPrice.priceValues.priceExclTax){
						priceValue = itemPrice.priceValues.priceExclTax || 0
					} else if (!this.excludeTax && itemPrice.priceValues && itemPrice.priceValues.priceInclTax) {
						priceValue = itemPrice.priceValues.priceInclTax || 0
					} else if (itemPrice.price) {
						priceValue = itemPrice.price || 0
					}
				}
			}
		}

		if (this.packageUpgrade && item && this.packageUpgradeBaseItem && item.id != this.packageUpgradeBaseItem.id) {
			priceValue = this.calculateUpgradePrice(priceValue)
		}

		return this.round(priceValue, 2);
	}

	round(number, decimalPlaces) {
		if (decimalPlaces < 0) throw new Error("decimalPlaces must be non-negative");
		
		let [integer, fraction = ""] = String(number).split(".");
		
		if (decimalPlaces === 0) {
			return String(Math.round(Number(integer + "." + (fraction || "0"))));
		}
		
		fraction = fraction.padEnd(decimalPlaces + 1, "0");
		
		let roundUp = fraction[decimalPlaces] >= "5";
		let resultFraction = fraction.slice(0, decimalPlaces);
		
		if (roundUp) {
			let carry = 1;
			let fractionArray = resultFraction.split("").reverse();
		
			for (let i = 0; i < fractionArray.length; i++) {
				let digit = Number(fractionArray[i]) + carry;
		
				if (digit === 10) {
					fractionArray[i] = "0";
				} else {
					fractionArray[i] = String(digit);
					carry = 0;
					break;
				}
			}
		
			resultFraction = fractionArray.reverse().join("");
		
			if (carry) {
				integer = String(Number(integer) + 1);
			}
		}
		
		let result = decimalPlaces > 0 ? `${integer}.${resultFraction}` : integer;

		return result;
	}

	calculateUpgradePrice(priceValue) {
		var returnValue = 0

		if (this.packageUpgrade && this.packageUpgradeBaseItem) {
			let upgradePrice = this.packageUpgradeBaseItem.retailPrice || 0

			var difference = 0
			if (!priceValue || priceValue == 0) {
				difference = 0
			} else {
				difference = (priceValue - upgradePrice) || 0
			}


			if (difference <= 0) {
				returnValue = 0
			} else {
				returnValue = Math.abs(difference)
			}
		}

		return returnValue
	}

	removeValue() {
		if (this.selectedItem && this.selectedItem.id) {
			this.listElement.find(`[data-grid-id="${this.selectedItem.id}"]`).removeClass("active")
			if (this.itemDeselected) {
				this.itemDeselected(this.selectedItem, this)
			}
			this.selectedItem = null
		}

		if (this.packageUpgrade && this.packageUpgradeBaseItem) {
			this.listElement.find('.grid-item.default-option').addClass("active")
		}

		this.updateHeadingInformation()
	}

	clearEqualHeightForShuffleItems(childItemSelector) {
		var elements = jQuery(childItemSelector);
		elements.map(function (index, element) { jQuery(element).css({ 'min-height': ''}) });
	}

	setEqualHeightForShuffleItems(childItemSelector) {
		//selects all items
		var elements = jQuery(childItemSelector);
		//puts the height of all items in an array
		var heights = elements.map(function (index, element) { return jQuery(element).height(); });
		//gets the highest value out of the array
		var maxHeight = Math.max(...heights);
		//sets height of all the items to be the same as the highest one
		elements.map(function (index, element) {
			if (jQuery(element).hasClass("my-sizer-element") == false) {
				jQuery(element).css({ 'min-height': `${maxHeight-1}px`});
			}
		});
	}

	loadExistingPage(pageId) {
		const page = this.pages[pageId]
		const items = page.items || []
		this.page = pageId
		this.updatePagination()
		this.buildGrid(items)
	}

	refresh() {
		if (this.hasTags && !this.selectedTag) {
			return
		}

		this.fetchPage(0, null, true, true)
	}

	initialise() {
		this.listElement.addClass(`grid-col-${this.columns || 3}`)
		if (this.tagCategoryGroup) {
			this.fetchTagCategories()
		} else {
			this.fetchPage(0, null)
		}

		this.updateHeadingInformation()
	}
}
